// extracted by mini-css-extract-plugin
module.exports =  {"gwSectionContainer":"FaqSectionComponent_gwSectionContainer__fxVDr","gwSectionTitle":"FaqSectionComponent_gwSectionTitle__86gIo"};